export default __webpack_public_path__ + "static/media/top-banner.8661c2fb.jpg";